module.exports = __webpack_public_path__ + "static/media/error.a8f2ce3c.svg";